import React from 'react';
import PropTypes from 'prop-types';
import { Button, Typography, CircularProgress } from '@mui/material';

const BaseButton = ({ children, variant = 'contained', color = 'primary', textColor, onClick, isLoading = false, ...props }) => {
  return (
    <Button 
      variant={variant}
      onClick={onClick}
      fullWidth
      disabled={isLoading}
      sx={{
        height: "40px"
      }}
      {...props}
    >
      {isLoading ? (
        <CircularProgress size={24} sx={{ color: textColor || "white" }} />
      ) : (
        <Typography
          variant="caption"
          sx={{
            color: textColor,
            padding: "0px",
            width: "100%",
            textAlign: "center",
          }}
        >
          {children}
        </Typography>
      )}
    </Button>
  );
};

BaseButton.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  onClick: PropTypes.func,
  isLoading: PropTypes.bool
};

export default BaseButton;
